/*
 * @Copyright (c): Knowdee All rights reserved.
 * @Description: webapp 入口文件
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-05 15:38:02
 * @LastEditTime: 2023-04-23 17:44:13
 * @FilePath: /client-h5-v2/src/main.ts
 */
// import '@/common-ts/vconsole'
import '@/process.env'
import '@/common-css/reset.css'
import '@/common-css/root.css'
import '@/common-css/element-plus-pc.scss'
import '@/common-css/element-plus-mobile.scss'
import 'animate.css/animate.compat.css'
import 'vant/lib/index.css'
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
import { onresolveparamsed } from '@/common-ts/location'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from '@/App.vue'
import store from '@/store'
import { lang } from './lang/index'
console.log('%c Chatbot Build-Time%c "' + process.env.version + '"', 'background:#0984e3 ; padding: 4px; border-radius: 3px 0 0 3px;  color: #fff', 'background:#41b883 ; padding: 4px; border-radius: 0 3px 3px 0;  color: #fff')
console.log('%c Chatbot Tags%c "' + process.env.tagVersion + '"', 'background:#0984e3 ; padding: 4px; border-radius: 3px 0 0 3px;  color: #fff', 'background:#41b883 ; padding: 4px; border-radius: 0 3px 3px 0;  color: #fff')
console.log('%c Cube Manual Version%c "' + process.env.cubeManualVersion + '"', 'background:#0984e3 ; padding: 4px; border-radius: 3px 0 0 3px;  color: #fff', 'background:#41b883 ; padding: 4px; border-radius: 0 3px 3px 0;  color: #fff')
onresolveparamsed(() => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const router = require('@/router')
  // 创建webapp
  const app = createApp(App)
  // 注册组件
  app.use(ContextMenu)
  app.use(ElementPlus)
  app.use(store)
  app.use(router.default)
  app.config.globalProperties.$routerBasePath = window.botV2GlobalProperties.BASE_PATH
  lang(app)

  // 挂载dom
  app.mount('#app')
})
